
const defaultAttrs = {"width":"13","height":"14","viewBox":"0 0 13 14"};
const svgInner = "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M11.803 1.697 1.197 12.303m0-10.606 10.606 10.606\"/>";

export default function CrossSvg(props = {}) {
  const className = props.className || props.class;
  const viewBox = defaultAttrs.viewBox;

  let attrs = 'xmlns="http://www.w3.org/2000/svg"';
  if (viewBox) attrs += ' viewBox="' + viewBox + '"';
  if (className) attrs += ' class="' + className + '"';
  if (props.width !== undefined) attrs += ' width="' + props.width + '"';
  if (props.height !== undefined) attrs += ' height="' + props.height + '"';

  return '<svg ' + attrs + '>' + svgInner + '</svg>';
}
